import clsx from 'clsx';

import { textOverflowClasses } from '../classes/textOverflowClasses';
import type { Adaptive } from '../types/Adaptive';
import type { TextOverflow } from '../types/TextOverflow';

export function composeTextOverflowClasses(overflow: Adaptive<TextOverflow>): string {
    if (typeof overflow === 'object') {
        return clsx(
            overflow.base && textOverflowClasses[overflow.base],
            overflow.sm && `sm:${textOverflowClasses[overflow.sm]}`,
            overflow.md && `md:${textOverflowClasses[overflow.md]}`,
            overflow.lg && `lg:${textOverflowClasses[overflow.lg]}`,
            overflow.xl && `xl:${textOverflowClasses[overflow.xl]}`,
            overflow['2xl'] && `2xl:${textOverflowClasses[overflow['2xl']]}`
        );
    }

    return textOverflowClasses[overflow];
}
